
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  FormGroup
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';

class PartnercsoportListaNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES
      formNev: '',
      formAzonosito: '',
      formStatusz: '',
      // checkboxes
      formCTipus: false,
      formCSzallitoVevo: false,
      formCAzonosito: false,
      formCStatusz: false,
      formCNev: false,
      formCKapcstart: false,
      formCCim: false,
      formCSzallcim: false,
      formCSzamcim: false,
      formCBankszamla: false,
      formCTel: false,
      formCEmail: false,
      formCAdoszam: false,
      formCKozadoszam: false,
      formCFajl: false,
      formCMegjegyzes: false,
      formCKedvezmeny: false,
      formCCegjegyzekszam: false,

      formMAdoazon: false,
      formMAdoszam: false,
      formMAzonosito: false,
      formMBankszamla: false,
      formMCim: false,
      formMEmail: false,
      formMFajl: false,
      formMGdpr: false,
      formMKedvezmeny: false,
      formMKozadoszam: false,
      formMMegjegyzes: false,
      formMNem: false,
      formMNev: false,
      formMNevnap: false,
      formMStatusz: false,
      formMSzallcim: false,
      formMSzallitovevo: false,
      formMSzamcim: false,
      formMSzulido: false,
      formMSzulnev: false,
      formMTaj: false,
      formMTel: false,
      formMTipus: false,

      statusz: [],
      statuszOptions: [],
      filterOptions: {},
    };
  }

  // componentDidMount() {
  //   this.listSzektor();
  // }

  // componentDidMount() {
  //   this.listPartnercsoport();
  //   this.getEnums();
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.type === 'PARTNERCSOP') {
  //     this.listPartnercsoport();
  //     this.getEnums();
  //   }
  // }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.listPartnercsoport();
        // this.getEnums();
      }
    }
  }

  // /** Dinamikusan töltendő szűkítő feltételek lekérdezése */
  // getEnums = () => {
  //   this.setState({ enums: [] });
  //   Services.listEnumPartnercsoport((err, res) => {
  //     if (!err) {
  //       this.setState({ enums: res[0] });
  //     }
  //   });
  // }

  initPartnercsoport = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initPartnercsoport((err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          // CLOUD UI 2023.10.12
          // formStatusz: this.nullToString(res[0].statusz && res[0].statusz.name),
          // checkbox
          formCTipus: res[0].cegkotelezoseg.c_tipus,
          formCSzallitoVevo: res[0].cegkotelezoseg.c_szallitovevo,
          formCAzonosito: res[0].cegkotelezoseg.c_azonosito,
          formCStatusz: res[0].cegkotelezoseg.c_statusz,
          formCNev: res[0].cegkotelezoseg.c_nev,
          formCKapcstart: res[0].cegkotelezoseg.c_kapcstart,
          formCCim: res[0].cegkotelezoseg.c_cim,
          formCSzallcim: res[0].cegkotelezoseg.c_szallcim,
          formCSzamcim: res[0].cegkotelezoseg.c_szamcim,
          formCBankszamla: res[0].cegkotelezoseg.c_bankszamla,
          formCTel: res[0].cegkotelezoseg.c_tel,
          formCEmail: res[0].cegkotelezoseg.c_email,
          formCAdoszam: res[0].cegkotelezoseg.c_adoszam,
          formCKozadoszam: res[0].cegkotelezoseg.c_kozadoszam,
          formCFajl: res[0].cegkotelezoseg.c_fajl,
          formCMegjegyzes: res[0].cegkotelezoseg.c_megjegyzes,
          formCKedvezmeny: res[0].cegkotelezoseg.c_kedvezmeny,
          formCCegjegyzekszam: res[0].cegkotelezoseg.c_cegjegyzek,

          formMAdoazon: res[0].maganszemelykotelezoseg.m_adoazon,
          formMAdoszam: res[0].maganszemelykotelezoseg.m_adoszam,
          formMAzonosito: res[0].maganszemelykotelezoseg.m_azonosito,
          formMBankszamla: res[0].maganszemelykotelezoseg.m_bankszamla,
          formMCim: res[0].maganszemelykotelezoseg.m_cim,
          formMEmail: res[0].maganszemelykotelezoseg.m_email,
          formMFajl: res[0].maganszemelykotelezoseg.m_fajl,
          formMGdpr: res[0].maganszemelykotelezoseg.m_gdpr,
          formMKedvezmeny: res[0].maganszemelykotelezoseg.m_kedvezmeny,
          formMKozadoszam: res[0].maganszemelykotelezoseg.m_kozadoszam,
          formMMegjegyzes: res[0].maganszemelykotelezoseg.m_megjegyzes,
          formMNem: res[0].maganszemelykotelezoseg.m_nem,
          formMNev: res[0].maganszemelykotelezoseg.m_nev,
          formMNevnap: res[0].maganszemelykotelezoseg.m_nevnap,
          formMStatusz: res[0].maganszemelykotelezoseg.m_statusz,
          formMSzallcim: res[0].maganszemelykotelezoseg.m_szallcim,
          formMSzallitovevo: res[0].maganszemelykotelezoseg.m_szallitovevo,
          formMSzamcim: res[0].maganszemelykotelezoseg.m_szamcim,
          formMSzulido: res[0].maganszemelykotelezoseg.m_szulido,
          formMSzulnev: res[0].maganszemelykotelezoseg.m_szulnev,
          formMTaj: res[0].maganszemelykotelezoseg.m_taj,
          formMTel: res[0].maganszemelykotelezoseg.m_tel,
          formMTipus: res[0].maganszemelykotelezoseg.m_tipus,
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  listPartnercsoport = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listPartnercsoport((err, res) => {
        if (!err) {
          let filters = {};
          let options = res[0].statusz.map((e) => {
            filters[e.name] = e.caption;

            return <option key={e.name} value={e.name}>{e.caption}</option>;
          });

          this.setState({
            tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0].list,
            filterOptions: filters,
            statusz: res[0].statusz,
            statuszOptions: options
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getPartnercsoport = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getPartnercsoport(id, (err, res) => {
      if (!err && (res[0].cegkotelezoseg && res[0].maganszemelykotelezoseg)) {
        this.setState({
          formStatus: 'DATA',
          formNev: this.nullToString(res[0].nev),
          formAzonosito: this.nullToString(res[0].azonosito),
          formStatusz: this.nullToString(res[0].statusz),
          // CLOUD UI 2023.10.12
          // formStatusz: this.nullToString(res[0].statusz && res[0].statusz.name),
          // checkbox
          formCTipus: res[0].cegkotelezoseg.c_tipus,
          formCSzallitoVevo: res[0].cegkotelezoseg.c_szallitovevo,
          formCAzonosito: res[0].cegkotelezoseg.c_azonosito,
          formCStatusz: res[0].cegkotelezoseg.c_statusz,
          formCNev: res[0].cegkotelezoseg.c_nev,
          formCKapcstart: res[0].cegkotelezoseg.c_kapcstart,
          formCCim: res[0].cegkotelezoseg.c_cim,
          formCSzallcim: res[0].cegkotelezoseg.c_szallcim,
          formCSzamcim: res[0].cegkotelezoseg.c_szamcim,
          formCBankszamla: res[0].cegkotelezoseg.c_bankszamla,
          formCTel: res[0].cegkotelezoseg.c_tel,
          formCEmail: res[0].cegkotelezoseg.c_email,
          formCAdoszam: res[0].cegkotelezoseg.c_adoszam,
          formCKozadoszam: res[0].cegkotelezoseg.c_kozadoszam,
          formCFajl: res[0].cegkotelezoseg.c_fajl,
          formCMegjegyzes: res[0].cegkotelezoseg.c_megjegyzes,
          formCKedvezmeny: res[0].cegkotelezoseg.c_kedvezmeny,
          formCCegjegyzekszam: res[0].cegkotelezoseg.c_cegjegyzek,

          formMAdoazon: res[0].maganszemelykotelezoseg.m_adoazon,
          formMAdoszam: res[0].maganszemelykotelezoseg.m_adoszam,
          formMAzonosito: res[0].maganszemelykotelezoseg.m_azonosito,
          formMBankszamla: res[0].maganszemelykotelezoseg.m_bankszamla,
          formMCim: res[0].maganszemelykotelezoseg.m_cim,
          formMEmail: res[0].maganszemelykotelezoseg.m_email,
          formMFajl: res[0].maganszemelykotelezoseg.m_fajl,
          formMGdpr: res[0].maganszemelykotelezoseg.m_gdpr,
          formMKedvezmeny: res[0].maganszemelykotelezoseg.m_kedvezmeny,
          formMKozadoszam: res[0].maganszemelykotelezoseg.m_kozadoszam,
          formMMegjegyzes: res[0].maganszemelykotelezoseg.m_megjegyzes,
          formMNem: res[0].maganszemelykotelezoseg.m_nem,
          formMNev: res[0].maganszemelykotelezoseg.m_nev,
          formMNevnap: res[0].maganszemelykotelezoseg.m_nevnap,
          formMStatusz: res[0].maganszemelykotelezoseg.m_statusz,
          formMSzallcim: res[0].maganszemelykotelezoseg.m_szallcim,
          formMSzallitovevo: res[0].maganszemelykotelezoseg.m_szallitovevo,
          formMSzamcim: res[0].maganszemelykotelezoseg.m_szamcim,
          formMSzulido: res[0].maganszemelykotelezoseg.m_szulido,
          formMSzulnev: res[0].maganszemelykotelezoseg.m_szulnev,
          formMTaj: res[0].maganszemelykotelezoseg.m_taj,
          formMTel: res[0].maganszemelykotelezoseg.m_tel,
          formMTipus: res[0].maganszemelykotelezoseg.m_tipus,
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getPartnercsoport(cell);
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  deletePartnercsoport = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deletePartnercsoport(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listPartnercsoport();
        this.props.globals.addSuccess('Partnercsoport törölve!');
      }
      this.setState({
        deleteButtonLoading: false
      });
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formNev: '',
      formAzonosito: '',
      formStatusz: 'AKTIV',
    }, () => {
      this.toggleFormModal();
      this.initPartnercsoport();
    });
  }

  submitForm = (e, values) => {
    const { currentId, formType } = this.state;
    const {
      formNev,
      formAzonosito,
      formStatusz,
      // checkboxes
      formCTipus,
      formCSzallitoVevo,
      formCAzonosito,
      formCStatusz,
      formCNev,
      formCKapcstart,
      formCCim,
      formCSzallcim,
      formCSzamcim,
      formCBankszamla,
      formCTel,
      formCEmail,
      formCAdoszam,
      formCKozadoszam,
      formCFajl,
      formCMegjegyzes,
      formCKedvezmeny,
      formCCegjegyzekszam,

      formMAdoazon,
      formMAdoszam,
      formMAzonosito,
      formMBankszamla,
      formMCim,
      formMEmail,
      formMFajl,
      formMGdpr,
      formMKedvezmeny,
      formMKozadoszam,
      formMMegjegyzes,
      formMNem,
      formMNev,
      formMNevnap,
      formMStatusz,
      formMSzallcim,
      formMSzallitovevo,
      formMSzamcim,
      formMSzulido,
      formMSzulnev,
      formMTaj,
      formMTel,
      formMTipus,
    } = values;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};

      submitObj.azonosito = this.emptyOrNull(formAzonosito);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.statusz = this.emptyOrNull(formStatusz);

      submitObj.cegkotelezoseg = {
        c_adoszam: formCAdoszam ? formCAdoszam : false,
        c_azonosito: formCAzonosito ? formCAzonosito : false,
        c_bankszamla: formCBankszamla ? formCBankszamla : false,
        c_cim: formCCim ? formCCim : false,
        c_email: formCEmail ? formCEmail : false,
        c_fajl: formCFajl ? formCFajl : false,
        c_kapcstart: formCKapcstart ? formCKapcstart : false,
        c_kedvezmeny: formCKedvezmeny ? formCKedvezmeny : false,
        c_kozadoszam: formCKozadoszam ? formCKozadoszam : false,
        c_megjegyzes: formCMegjegyzes ? formCMegjegyzes : false,
        c_nev: formCNev ? formCNev : false,
        c_statusz: formCStatusz ? formCStatusz : false,
        c_szallcim: formCSzallcim ? formCSzallcim : false,
        c_szallitovevo: formCSzallitoVevo ? formCSzallitoVevo : false,
        c_szamcim: formCSzamcim ? formCSzamcim : false,
        c_tel: formCTel ? formCTel : false,
        c_tipus: formCTipus ? formCTipus : false,
        c_cegjegyzek: formCCegjegyzekszam ? formCCegjegyzekszam : false,
      };

      submitObj.maganszemelykotelezoseg = {
        m_adoazon: formMAdoazon ? formMAdoazon : false,
        m_adoszam: formMAdoszam ? formMAdoszam : false,
        m_azonosito: formMAzonosito ? formMAzonosito : false,
        m_bankszamla: formMBankszamla ? formMBankszamla : false,
        m_cim: formMCim ? formMCim : false,
        m_email: formMEmail ? formMEmail : false,
        m_fajl: formMFajl ? formMFajl : false,
        m_gdpr: formMGdpr ? formMGdpr : false,
        m_kedvezmeny: formMKedvezmeny ? formMKedvezmeny : false,
        m_kozadoszam: formMKozadoszam ? formMKozadoszam : false,
        m_megjegyzes: formMMegjegyzes ? formMMegjegyzes : false,
        m_nem: formMNem ? formMNem : false,
        m_nev: formMNev ? formMNev : false,
        m_nevnap: formMNevnap ? formMNevnap : false,
        m_statusz: formMStatusz ? formMStatusz : false,
        m_szallcim: formMSzallcim ? formMSzallcim : false,
        m_szallitovevo: formMSzallitovevo ? formMSzallitovevo : false,
        m_szamcim: formMSzamcim ? formMSzamcim : false,
        m_szulido: formMSzulido ? formMSzulido : false,
        m_szulnev: formMSzulnev ? formMSzulnev : false,
        m_taj: formMTaj ? formMTaj : false,
        m_tel: formMTel ? formMTel : false,
        m_tipus: formMTipus ? formMTipus : false,
      };

      Services.addPartnercsoport(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Partnercsoport felvéve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listPartnercsoport();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.azonosito = this.emptyOrNull(formAzonosito);
      submitObj.nev = this.emptyOrNull(formNev);
      submitObj.statusz = this.emptyOrNull(formStatusz);

      submitObj.cegkotelezoseg = {
        c_adoszam: formCAdoszam ? formCAdoszam : false,
        c_azonosito: formCAzonosito ? formCAzonosito : false,
        c_bankszamla: formCBankszamla ? formCBankszamla : false,
        c_cim: formCCim ? formCCim : false,
        c_email: formCEmail ? formCEmail : false,
        c_fajl: formCFajl ? formCFajl : false,
        c_kapcstart: formCKapcstart ? formCKapcstart : false,
        c_kedvezmeny: formCKedvezmeny ? formCKedvezmeny : false,
        c_kozadoszam: formCKozadoszam ? formCKozadoszam : false,
        c_megjegyzes: formCMegjegyzes ? formCMegjegyzes : false,
        c_nev: formCNev ? formCNev : false,
        c_statusz: formCStatusz ? formCStatusz : false,
        c_szallcim: formCSzallcim ? formCSzallcim : false,
        c_szallitovevo: formCSzallitoVevo ? formCSzallitoVevo : false,
        c_szamcim: formCSzamcim ? formCSzamcim : false,
        c_tel: formCTel ? formCTel : false,
        c_tipus: formCTipus ? formCTipus : false,
        c_cegjegyzek: formCCegjegyzekszam ? formCCegjegyzekszam : false,
      };

      submitObj.maganszemelykotelezoseg = {
        m_adoazon: formMAdoazon ? formMAdoazon : false,
        m_adoszam: formMAdoszam ? formMAdoszam : false,
        m_azonosito: formMAzonosito ? formMAzonosito : false,
        m_bankszamla: formMBankszamla ? formMBankszamla : false,
        m_cim: formMCim ? formMCim : false,
        m_email: formMEmail ? formMEmail : false,
        m_fajl: formMFajl ? formMFajl : false,
        m_gdpr: formMGdpr ? formMGdpr : false,
        m_kedvezmeny: formMKedvezmeny ? formMKedvezmeny : false,
        m_kozadoszam: formMKozadoszam ? formMKozadoszam : false,
        m_megjegyzes: formMMegjegyzes ? formMMegjegyzes : false,
        m_nem: formMNem ? formMNem : false,
        m_nev: formMNev ? formMNev : false,
        m_nevnap: formMNevnap ? formMNevnap : false,
        m_statusz: formMStatusz ? formMStatusz : false,
        m_szallcim: formMSzallcim ? formMSzallcim : false,
        m_szallitovevo: formMSzallitovevo ? formMSzallitovevo : false,
        m_szamcim: formMSzamcim ? formMSzamcim : false,
        m_szulido: formMSzulido ? formMSzulido : false,
        m_szulnev: formMSzulnev ? formMSzulnev : false,
        m_taj: formMTaj ? formMTaj : false,
        m_tel: formMTel ? formMTel : false,
        m_tipus: formMTipus ? formMTipus : false,
      };

      Services.editPartnercsoport(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Partnercsoport módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listPartnercsoport();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {this.props.globals.hasRole(['PARTNER_CSOPORT'], true) && (
            <React.Fragment>
              {row.mod && (
                <React.Fragment>
                  <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                    {'Módosítás'}
                  </UncontrolledTooltip>
                </React.Fragment>
              )}
              <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
      color: this.getCorrectTextColor('#' + szinkod)
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új partnercsoport létrehozása';
      case 'MOD':
        return 'Partnercsoport módosítása';
      default:
        return '';
    }
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }
  // CLOUD UI 2023.10.12
  // tableStatusFormatter = (cell) => {
  //   return cell === 'AKTIV'
  //     ? <span className="badge badge-success">Aktív</span>
  //     : <span className="badge badge-secondary">Inaktív</span>;
  // }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    // const selectOptions = {
    //   AKTIV: 'Aktív',
    //   INAKTIV: 'Inaktív',
    // };

    const columns = [
      {
        dataField: 'azonosito',
        text: 'Partnercsoport azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Partnercsoport neve',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'statusz',
        align: 'center',
        text: 'Státusz',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.statusFormatter
        // CLOUD UI 2023.10.12
        // formatter: this.tableStatusFormatter
      },
      // {
      //   dataField: 'statusz',
      //   text: 'Státusz',
      //   filter: selectFilter({
      //     options: selectOptions,
      //     placeholder: 'Összes',
      //   }),
      //   style: {
      //     wordBreak: 'break-all',
      //     whiteSpace: 'pre-line',
      //     textAlign: 'center'
      //   },
      //   formatter: this.tableBooleanFormatter,
      //   sort: true
      // },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['PARTNER_CSOPORT'], true),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

renderForm = () => {
  const {
    formNev,
    formAzonosito,
    formStatusz,
    // checkboxes
    formCTipus,
    formCSzallitoVevo,
    formCAzonosito,
    formCStatusz,
    formCNev,
    formCKapcstart,
    formCCim,
    formCSzallcim,
    formCSzamcim,
    formCBankszamla,
    formCTel,
    formCEmail,
    formCAdoszam,
    formCKozadoszam,
    formCFajl,
    formCMegjegyzes,
    formCKedvezmeny,
    formCCegjegyzekszam,

    formMAdoazon,
    formMAdoszam,
    formMAzonosito,
    formMBankszamla,
    formMCim,
    formMEmail,
    formMFajl,
    formMGdpr,
    formMKedvezmeny,
    formMKozadoszam,
    formMMegjegyzes,
    formMNem,
    formMNev,
    formMNevnap,
    formMStatusz,
    formMSzallcim,
    formMSzallitovevo,
    formMSzamcim,
    formMSzulido,
    formMSzulnev,
    formMTaj,
    formMTel,
    formMTipus,

    formType
  } = this.state;

  const titleStyle = {
    marginBottom: 20,
    marginTop: 10,
    marginLeft: 10
  };

  const titleGDPRStyle = {
    marginBottom: 20,
    paddingBottom: 5,
    marginLeft: 10,
    borderBottom: '5px solid #cfd8dc'
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-4">
          <RFField
            type="text"
            label="Partnercsoport azonosító: *"
            name="formAzonosito"
            id="formAzonosito"
            maxLength="10"
            disabled={formType === 'MOD'}
            value={formAzonosito}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="col-md-4">
          <RFField
            type="text"
            label="Partnercsoport neve: *"
            name="formNev"
            id="formNev"
            value={formNev}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="col-md-4">
            <RFField
              type="select"
              name="formStatusz"
              id="formStatusz"
              label="Státusz: *"
              errorMessage="Kötelező mező!"
              required
              value={formStatusz}
              onChange={this.handleInputChange}
              defaultSelect={<option value="">Válassz státuszt...</option>}
              selectOptions={this.state.statuszOptions}
            />
        </div>
        <div className="col-md-12">
          <div>
            <h5 style={titleStyle}>
              Kötelezően kitöltendő mezők:
            </h5>
          </div>
        </div>

        <div className="col-md-6">
          <div>
            <h6 style={titleGDPRStyle}>
              {'Cég típusú partner:'.toUpperCase()}
            </h6>
          </div>
          <div className="row">
          <div className="col-md-6">
          <div>
            <h6 style={titleStyle}>
              {'Alapadatok'}
            </h6>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Típus"
                type="checkbox"
                name="formCTipus"
                id="formCTipus"
                value={formCTipus}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Szállító/Vevő"
                type="checkbox"
                name="formCSzallitoVevo"
                id="formCSzallitoVevo"
                value={formCSzallitoVevo}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Azonosító"
                type="checkbox"
                name="formCAzonosito"
                id="formCAzonosito"
                value={formCAzonosito}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Státusz"
                type="checkbox"
                name="formCStatusz"
                id="formCStatusz"
                value={formCStatusz}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Név"
                type="checkbox"
                name="formCNev"
                id="formCNev"
                value={formCNev}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Kapcsolattartó"
                type="checkbox"
                name="formCKapcstart"
                id="formCKapcstart"
                value={formCKapcstart}
                onChange={this.handleInputChange}
                disabled={formCKapcstart === null}
              />
            </FormGroup>
          </div>
          <div>
            <h6 style={titleStyle}>
              {'Címek, elérhetőségek'}
            </h6>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Hivatalos cím"
                type="checkbox"
                name="formCCim"
                id="formCCim"
                value={formCCim}
                onChange={this.handleInputChange}
                disabled={formCCim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Szállítasi cím"
                type="checkbox"
                name="formCSzallcim"
                id="formCSzallcim"
                value={formCSzallcim}
                onChange={this.handleInputChange}
                disabled={formCSzallcim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Levelezési cím"
                type="checkbox"
                name="formCSzamcim"
                id="formCSzamcim"
                value={formCSzamcim}
                onChange={this.handleInputChange}
                disabled={formCSzamcim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Telefonszámok"
                type="checkbox"
                name="formCTel"
                id="formCTel"
                value={formCTel}
                onChange={this.handleInputChange}
                disabled={formCTel === null}
              />
            </FormGroup>
          </div>
          </div>
            <div className="col-md-6">
              <div>
                <h6 style={titleStyle}>
                  {'Egyéb adatok'}
                </h6>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Bank adatok"
                    type="checkbox"
                    name="formCBankszamla"
                    id="formCBankszamla"
                    value={formCBankszamla}
                    onChange={this.handleInputChange}
                    disabled={formCBankszamla === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Email"
                    type="checkbox"
                    name="formCEmail"
                    id="formCEmail"
                    value={formCEmail}
                    onChange={this.handleInputChange}
                    disabled={formCEmail === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Adószám"
                    type="checkbox"
                    name="formCAdoszam"
                    id="formCAdoszam"
                    value={formCAdoszam}
                    onChange={this.handleInputChange}
                    disabled={formCAdoszam === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Közösségi adószám"
                    type="checkbox"
                    name="formCKozadoszam"
                    id="formCKozadoszam"
                    value={formCKozadoszam}
                    onChange={this.handleInputChange}
                    disabled={formCKozadoszam === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Kedvezmény"
                    type="checkbox"
                    name="formCKedvezmeny"
                    id="formCKedvezmeny"
                    value={formCKedvezmeny}
                    onChange={this.handleInputChange}
                    disabled={formCKedvezmeny === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Fájlkezelés"
                    type="checkbox"
                    name="formCFajl"
                    id="formCFajl"
                    value={formCFajl}
                    onChange={this.handleInputChange}
                    disabled={formCFajl === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Megjegyzés"
                    type="checkbox"
                    name="formCMegjegyzes"
                    id="formCMegjegyzes"
                    value={formCMegjegyzes}
                    onChange={this.handleInputChange}
                    disabled={formCMegjegyzes === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label={'Cégjegyzékszám'}
                    type="checkbox"
                    name="formCCegjegyzekszam"
                    id="formCCegjegyzekszam"
                    value={formCCegjegyzekszam}
                    onChange={this.handleInputChange}
                    disabled={formCCegjegyzekszam === null}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <h6 style={titleGDPRStyle}>
              {'Magánszemély típusú partner:'.toUpperCase()}
            </h6>
          </div>
          <div className="row">
          <div className="col-md-6">
          <div>
            <h6 style={titleStyle}>
              {'Alapadatok'}
            </h6>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Típus"
                type="checkbox"
                name="formMTipus"
                id="formMTipus"
                value={formMTipus}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Szállító/Vevő"
                type="checkbox"
                name="formMSzallitovevo"
                id="formMSzallitovevo"
                value={formMSzallitovevo}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Azonosító"
                type="checkbox"
                name="formMAzonosito"
                id="formMAzonosito"
                value={formMAzonosito}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Státusz"
                type="checkbox"
                name="formMStatusz"
                id="formMStatusz"
                value={formMStatusz}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Név"
                type="checkbox"
                name="formMNev"
                id="formMNev"
                value={formMNev}
                onChange={this.handleInputChange}
                disabled
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Születési vezetéknév és keresztnév"
                type="checkbox"
                name="formMSzulnev"
                id="formMSzulnev"
                value={formMSzulnev}
                onChange={this.handleInputChange}
                disabled={formMSzulnev === null}
              />
            </FormGroup>
          </div>
          <div>
            <h6 style={titleStyle}>
              {'Címek, elérhetőségek'}
            </h6>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Hivatalos cím"
                type="checkbox"
                name="formMCim"
                id="formMCim"
                value={formMCim}
                onChange={this.handleInputChange}
                disabled={formMCim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Szállítasi cím"
                type="checkbox"
                name="formMSzallcim"
                id="formMSzallcim"
                value={formMSzallcim}
                onChange={this.handleInputChange}
                disabled={formMSzallcim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Levelezési cím"
                type="checkbox"
                name="formMSzamcim"
                id="formMSzamcim"
                value={formMSzamcim}
                onChange={this.handleInputChange}
                disabled={formMSzamcim === null}
              />
            </FormGroup>
          </div>
          <div style={{ paddingLeft: '20px' }}>
            <FormGroup>
              <RFField
                label="Telefonszámok"
                type="checkbox"
                name="formMTel"
                id="formMTel"
                value={formMTel}
                onChange={this.handleInputChange}
                disabled={formMTel === null}
              />
            </FormGroup>
          </div>
          </div>
            <div className="col-md-6">
              <div>
                <h6 style={titleStyle}>
                  {'Egyéb adatok'}
                </h6>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Bank adatok"
                    type="checkbox"
                    name="formMBankszamla"
                    id="formMBankszamla"
                    value={formMBankszamla}
                    onChange={this.handleInputChange}
                    disabled={formMBankszamla === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Email"
                    type="checkbox"
                    name="formMEmail"
                    id="formMEmail"
                    value={formMEmail}
                    onChange={this.handleInputChange}
                    disabled={formMEmail === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Születési idő"
                    type="checkbox"
                    name="formMSzulido"
                    id="formMSzulido"
                    value={formMSzulido}
                    onChange={this.handleInputChange}
                    disabled={formMSzulido === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField 
                    label="Taj szám"
                    type="checkbox"
                    name="formMTaj"
                    id="formMTaj"
                    value={formMTaj}
                    onChange={this.handleInputChange}
                    disabled={formMTaj === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="GDPR hozzájárulás"
                    type="checkbox"
                    name="formMGdpr"
                    id="formMGdpr"
                    value={formMGdpr}
                    onChange={this.handleInputChange}
                    disabled
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Névnap"
                    type="checkbox"
                    name="formMNevnap"
                    id="formMNevnap"
                    value={formMNevnap}
                    onChange={this.handleInputChange}
                    disabled={formMNevnap === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Nem"
                    type="checkbox"
                    name="formMNem"
                    id="formMNem"
                    value={formMNem}
                    onChange={this.handleInputChange}
                    disabled={formMNem === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Adószám"
                    type="checkbox"
                    name="formMAdoszam"
                    id="formMAdoszam"
                    value={formMAdoszam}
                    onChange={this.handleInputChange}
                    disabled={formMAdoszam === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Adóazonosító jel"
                    type="checkbox"
                    name="formMAdoazon"
                    id="formMAdoazon"
                    value={formMAdoazon}
                    onChange={this.handleInputChange}
                    disabled={formMAdoazon === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Közösségi adószám"
                    type="checkbox"
                    name="formMKozadoszam"
                    id="formMKozadoszam"
                    value={formMKozadoszam}
                    onChange={this.handleInputChange}
                    disabled={formMKozadoszam === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Kedvezmény"
                    type="checkbox"
                    name="formMKedvezmeny"
                    id="formMKedvezmeny"
                    value={formMKedvezmeny}
                    onChange={this.handleInputChange}
                    disabled={formMKedvezmeny === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Fájlkezelés"
                    type="checkbox"
                    name="formMFajl"
                    id="formMFajl"
                    value={formMFajl}
                    onChange={this.handleInputChange}
                    disabled={formMFajl === null}
                  />
                </FormGroup>
              </div>
              <div style={{ paddingLeft: '20px' }}>
                <FormGroup>
                  <RFField
                    label="Megjegyzés"
                    type="checkbox"
                    name="formMMegjegyzes"
                    id="formMMegjegyzes"
                    value={formMMegjegyzes}
                    onChange={this.handleInputChange}
                    disabled={formMMegjegyzes === null}
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
         {this.props.globals.hasRole(['PARTNER_CSOPORT'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új partnercsoport'}
            </Button>
          )}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => {
                this.listPartnercsoport();
                // this.getEnums();
              }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
        <RFForm
          modal
          onSubmit={this.submitForm}
          title={this.renderFormTitle()}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          <div className="roq">
            <div className="col-md-12">
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => { this.getPartnercsoport(this.state.currentId); }}
                />),
                DATA: (this.renderForm())
              }[this.state.formStatus]}
            </div>
          </div>
        </RFForm>


      </Modal>
      <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
        <ModalHeader>Törlés</ModalHeader>
        <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
        <ModalFooter>
          <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            onClick={() => this.deletePartnercsoport()}
            loading={this.state.deleteButtonLoading}
          >
            {'Igen'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
}

PartnercsoportListaNew.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default PartnercsoportListaNew;
